import {optimizationStateStatuses} from "../OptizationState";

export const OptimizationsFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
        "filterFn": (value, filterValue) => value === null ? "не занумерован".includes(filterValue.toLowerCase()) : value.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "optimized",
        "id": "optimized",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "optimizationState",
        "id": "optimizationState",
        "filterFn": (value, filterValue) => optimizationStateStatuses[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]